<div *ngFor="let item of data">
    <app-title-section [title]="item.title" [type]="'title'">
    </app-title-section>
    <div (click)="activateItem(data[0].features, itemFeatures.id)"
        *ngFor="let itemFeatures of item.features; let i = index"
        class="flex flex-col items-start justify-start w-full px-0 py-0 mx-0 overflow-hidden rounded-lg shadow-lg cursor-pointer "
        [ngClass]="itemFeatures.active ?'mb-5':'mb-2'">

        <div class="w-full px-5 py-3 font-semibold text-white hover:bg-sigma-100"
            [ngClass]="itemFeatures.active ?'bg-sigma-100 text-2xl':'bg-sigma-200 text-xl'">
            {{itemFeatures.title}}
        </div>

        <div class="w-full text-2xl text-justify bg-gray-200 cursor-default panel"
            [ngClass]="itemFeatures.active ? 'active':'inactive'">
            <p class="p-6">
                {{itemFeatures.description}}
            </p>
        </div>
    </div>
</div>